import { render, staticRenderFns } from "./WebCastDetail.vue?vue&type=template&id=bc5930c2&scoped=true&"
import script from "./WebCastDetail.vue?vue&type=script&lang=js&"
export * from "./WebCastDetail.vue?vue&type=script&lang=js&"
import style0 from "./WebCastDetail.vue?vue&type=style&index=0&id=bc5930c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5930c2",
  null
  
)

export default component.exports